import React, { useState } from 'react';
import { PIFlowLeftNavBar } from '../../ReusableComp/NavBarLeft';
import NavigationBar from '../../ReusableComp/NavigationBar';
import Select from '../../ReusableComp/Select';
import {  Col, Container, Row, Stack, Table, Button } from 'react-bootstrap';
import Accordion from 'react-bootstrap/Accordion';
import { useNavigate ,useLocation} from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { getAdvEventOfSubject, getSubjProfDetails, getPiStudies, getEventDetails, getAllCausalities, getAllOutComes, getActionTaken, getActionTakenForAE, resetAEStepperData, resetSubjectProfile,getPmsNotifications } from '../../../Redux/actions/actions';
import { SUBJECT_STATUS_OFF_STUDY, SUBJECT_STATUS_ON_GOING_ADVERSE_EVENT, SUBJECT_STATUS_ON_STUDY, TOGGLE_YES, base_url, PRINCIPAL_INVESTIGATOR } from '../../../utilities';
import moment from 'moment';
import * as XLSX from "xlsx";
import FileSaver from "file-saver";
import { PopUpAlert } from '../../ReusableComp/PopUpModal';
import { formatDate } from '../../ReusableComp/dateFormat';

const PISubjectsList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const subjectList = useSelector((state) => state.subjectList);
    const subjectCounts = useSelector((state) => state.subjectCounts);
    const aeSubject = useSelector((state) => state.getAeOfSubj);
    const subjectProfile = useSelector((state) => state.getSubProf);
    const studyDtls = useSelector((state) => state.studyInfo);
    const piStudyData = useSelector((state) => (state.piStudyList));
     
    const [currentPage, setCurrentPage] = useState((location.state==undefined|| location.state==null)?1:location.state.data)
    const [filteredData, setFilteredData] = useState([])
    const [searchText, setSearchText] = useState('');
    const [doseOptions, setDoseOptions] = useState(null);
    const [statusOptions, setStatusOptions] = useState(null);
    const [doseSelected, setDoseSelected] = useState("");
    const [statusSelected, setStatusSelected] = useState("");
    const [subjProfData, setSubjProfData] = useState({});
    let [loading_flag, Setloading_flag] = useState(false);
    const [asc,setAsC]=useState(false);
    const [desc,setDesc]=useState(false);
    const getEventFlag = useSelector((state) => state.getEventFlag);
    const [selectedOption, setSelectedOption] = useState(getEventFlag?.option);

    const handleRadioChange = (selectedValue) => {
        setSelectedOption(selectedValue);
        if(subjectList){
            if (selectedValue === 'serious_adverse_events') {
                setFilteredData(subjectList.filter(i => i.sae_count>0))
              } else if (selectedValue === 'adverse_events') {
                setFilteredData(subjectList.filter(i => i.ae_count>0))
              }else if (selectedValue === 'all_events') {
                setFilteredData(subjectList)
              }
        }
      };

    useEffect(() => {
        if(location.state !== null ){
            handleSubjectData(location.state?.data);
            navigate({ state: null });
          }
        Setloading_flag(true);
        if(subjectList){
            if(selectedOption ==="serious_adverse_events"){
                setFilteredData(subjectList.filter(i => i.sae_count>0))
              }else if(selectedOption ==="adverse_events"){
                setFilteredData(subjectList.filter(i => i.ae_count>0))
              }else if(selectedOption==="all_events"){
                setFilteredData(subjectList)
              }else {
                setSelectedOption("all_events")
                setFilteredData(subjectList)
              }
        }

        if (!localStorage.getItem("login_user_name")) {
            navigate("/");
        }
        dispatch(getPiStudies(localStorage.pi_id))
        disableBackButton();
        setTimeout(() => {
            Setloading_flag(false);
        }, 600);

    }, [dispatch, localStorage.pi_id,localStorage.study_id, subjectList !== null ]);
        useEffect(() => {
            if (subjectList) {
                setFilteredData(subjectList)
                if (subjectProfile && modifiedData) {
                    Setloading_flag(false)
                }
              }
          },[subjectList,subjectProfile])


    function disableBackButton() {
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', function (event) {
            window.history.pushState(null, null, window.location.pathname);
        });
    }

  


    const [myArray, setMyArray] = useState([])
    useEffect(() => {
        const dateOfReport = aeSubject && aeSubject?.date_of_administration;

        if (subjectProfile !== null) {
            setSubjProfData({
                subject_dose_id: subjectProfile && subjectProfile['SubjectDoses.subject_dose_id'],
                subject_id: subjectProfile.subject_id,
                study_id: subjectProfile.study_id,
                date_of_administration: dateOfReport
            });
            let status = `${subjectProfile['SubjectDoses.status']}`
            
            setMyArray([
                { id: 1, title: subjectProfile['Study.study_name'], description: 'Study' },
                { id: 2, title: `D${subjectProfile['SubjectDoses.dose']}`, description: 'Dose' },
                { id: 3, title: `${subjectProfile['PrincipalInvestigator.name']}`, description: 'Principal Investigator' },
                {
                    id: 4, description: "Status", title:
                        status == SUBJECT_STATUS_ON_GOING_ADVERSE_EVENT ? 'On going adverse event' :
                            status == SUBJECT_STATUS_ON_STUDY ? 'On study' :
                                status == SUBJECT_STATUS_OFF_STUDY ? 'Concluded study' : ''
                }
            ])
        }        
    }, [dispatch, subjectProfile]);

    useEffect(() => {
        if (subjectList?.length > 0) {
            const uniqueDoses = Array.from(new Set(subjectList.map(json => json.dose))).filter(Boolean);
            const optionsList = uniqueDoses.map((dose) => ({
                label: dose,
                value: dose
            }));
            setDoseOptions(optionsList);

            const uniqueStatus = Array.from(new Set(subjectList?.map(json => json.status))).filter(Boolean);
            const optionsStatusList = uniqueStatus?.map((val) => ({
                label: val,
                value: val
            }));
            setStatusOptions(optionsStatusList);
        }

    }, [subjectList]);
    const dateOfReport = aeSubject?.date_of_administration;
    const lastDayActiveFollowUp = aeSubject?.last_day_active_follow_up;
    const stepperData = [];
    const afterFollowUpStepperData = [] ;
    const date = new Date(dateOfReport);
    const startDate = new Date(dateOfReport);
    while (date <= new Date(lastDayActiveFollowUp)) {
        stepperData.push({
            day: `Day ${Math.round((date - startDate) / (1000*3600*24))}`, //`Day${stepperData.length}`,
            dateOfevent: date.toISOString().split("T")[0]
        });
        date.setDate(date.getDate() + 1);
    }
    const events = aeSubject?.events;

    var i = 0;
    if(events) 
    {
        while(i < Object.keys(events).length){
            const eventDate = stepperData.filter(date => date.dateOfevent == (Object.keys(events)[i]).toString().split("T")[0]);
            if(eventDate.length == 0){
                const test = (Object.keys(events)[i]).toString().split("T")[0]
                const date = new Date(test)
                afterFollowUpStepperData.push({
                    day: `Day ${Math.round((date - startDate) / (1000*3600*24))}`, // `Day${stepperData.length + afterFollowUpStepperData.length}`,
                    dateOfevent: (Object.keys(events)[i]).toString().split("T")[0],
                })
            }
            i = i + 1
        }
    }

    const modifiedData1 = stepperData.map(day => {
        const eventDate = Object.keys(events).find(date => date === day.dateOfevent);
        if (eventDate) {
            return {
                ...day,
                eventClassification: [events[eventDate]]
            };
        }
        return day;
    });

    const modifiedData2 = afterFollowUpStepperData?.map((event) => {
        return {
            ...event,
            eventClassification: [events[event.dateOfevent]]
        };
    });

    const modifiedData = modifiedData2?.length > 0 ? [...modifiedData1, ...modifiedData2] : [...modifiedData1]

    const dashboardCards = [
        {
            count: subjectCounts?.seriousAdverseEventsCount,
            image: './images/icons/exclamatory.svg',
            desc: 'Serious Adverse Events',
            bgcolor: '#D14141',
            id:"serious_adverse_events"
        },
        {
            count: subjectCounts?.adverseEventsCount,
            image: './images/icons/smiley.svg',
            desc: 'Adverse Events',
            bgcolor: '#EA9E4F',
            id:"adverse_events"
        },
        {
            count: subjectCounts?.subjectsCount,
            image: './images/icons/subjects_white.svg',
            desc: 'Total Subjects',
            bgcolor: '#8DA2B5',
            id:"all_events"
        },
    ]

    const handleStudyChange = () => {
        setFilteredData(null);
        setSearchText('');
    }


    const handleSearchData = (event) => {
        const searchText = event.target.value.toLowerCase();
        setSearchText(searchText);
        const filteredData = subjectList?.filter((item) => {
            const phnNum = item.phone_number;
            const subj_id = item.subject_code
            return (subj_id.toLowerCase()?.includes(searchText) ||
                String(phnNum)?.includes(searchText)
            );
        });
        setFilteredData(filteredData)

    }

    function calculateBMI(weight, height) {
        if (isNaN(weight) || isNaN(height) || height === null) {
            return "0"; // Display "N/A" if either weight or height is not a number
        }
        const bmi = weight / ((height / 100) ** 2);

        return bmi.toFixed(1);
    }

    // const [subjData, setSubjData] = useState([])
    const [studyDropdwn, setStudyDropdwn] = useState(false)

    const handleSubjectData = (data) => {
        Setloading_flag(true)
        setStudyDropdwn(true)
        let subjectId = data.subject_id
        
        let dose = parseInt(data?.dose?.match(/\d+/)[0])
        setCurrentPage(2)
        // setSubjData(data)
        if (subjectId) {
            Setloading_flag(true)
            dispatch(getAdvEventOfSubject(subjectId, dose))
            dispatch(getSubjProfDetails({ "subject_id": subjectId, "dose": dose }))
        }

    }


    function addAdverseEvent() {

        if (subjProfData !== '') { navigate('/addnewaetosubject', { state: subjProfData }) }
    }
    function handlePageandStudy() {
        Setloading_flag(false)
        dispatch(resetAEStepperData())
        dispatch(resetSubjectProfile())
        setStudyDropdwn(false)
        setCurrentPage(1)
    }

    const getRoleCode = (data) => {
    }

    const handleClearFilters = () => {
        setDoseSelected("");
        setStatusSelected("");
        setFilteredData(subjectList);
    }

    const handleAE = (adverse_event_mapping_id) => {
        let obj = {
            subject_id: subjectProfile.subject_id,
            dose: subjectProfile['SubjectDoses.dose']
        }
        dispatch(getPmsNotifications({
            user_id: localStorage.login_user_id,
            pi_id:localStorage.pi_id,
            user_persona: PRINCIPAL_INVESTIGATOR
      }))
        dispatch(getAllOutComes())
        dispatch(getActionTaken())
        dispatch(getAllCausalities())
        dispatch(getActionTakenForAE())
        dispatch(getSubjProfDetails(obj))
        navigate('/updateAEDetails',{state:{
                adverse_event_mapping_id:adverse_event_mapping_id,
            }})
    }
    const handleOptionSelectDose = (e) => {
        let val = e.target.value;
        if (val === 'Doses') {
            val = "";
        }
        setDoseSelected(val)
        const filteredData = subjectList.filter((item) => {
            // Convert relevant properties to lowercase for case-insensitive search
            const { dose, status } = item;
           
            const formattedSubjectCode = dose;
            const formattedPhoneNumber = status;
            // Check if subject_id or subject_code contains the search text
            return (
                formattedSubjectCode?.includes(val) &&
                formattedPhoneNumber?.includes(statusSelected)
            );
        });
        // Update the table or do whatever you want with the filteredData
        setFilteredData(filteredData);

    }

    const handleOptionSelectStatus = (e) => {

        let val = e.target.value;
        if (val === 'Status') {
            val = "";
        }

        setStatusSelected(val)
        const filteredData = subjectList.filter((item) => {
            const { dose, status } = item;

            const formattedSubjectCode = dose;
            const formattedPhoneNumber = status;
            return (
                formattedSubjectCode?.includes(doseSelected) &&
                formattedPhoneNumber?.includes(val)
            );
        });
        setFilteredData(filteredData);

    }
    const [studyOption, setStudyOption] = useState()

    const handleOptionChange = (e, key, value) => {
        setStudyOption(value)
    }
    const [placeHoldTxt, setPlaceHoldTxt] = useState("")
    useEffect(() => {
        if(window.screen.width<=720){
            setPlaceHoldTxt("Search with Subject ID")
        }else{
            setPlaceHoldTxt("Search with Subject ID or Phone number")

        }


    }, [window.screen.width])
 
   
    const handleAscending = () => {
        setAsC(true);
        setDesc(false);
      
        const sortedData = [...filteredData];  
        sortedData.sort((a, b) => {
          const subjectCodeA = a.subject_code;
          const subjectCodeB = b.subject_code;
          return subjectCodeA.localeCompare(subjectCodeB);
        });
        setFilteredData(sortedData);
      };
      
      const handleDescending = () => {
        setDesc(true);
        setAsC(false);
      
        const sortedData = [...filteredData];
      
        sortedData.sort((a, b) => {
          const subjectCodeA = a.subject_code;
          const subjectCodeB = b.subject_code;
          return subjectCodeB.localeCompare(subjectCodeA);
        });
      
        setFilteredData(sortedData);
      };
      
      const getStatusTextColor = (status) => {
        switch (status) {
          case 'ON STUDY':
            return 'black';
          case 'CONCLUDED STUDY':
            return 'green';
          case 'ON GOING ADVERSE EVENT':
            return 'red';
          default:
            return ''; 
        }
      };
      const handleCheckEstimation=()=>{
        if(studyDtls?.estimated_subjects_reached===1){
            setOpen(true)
        }else{
            navigate('/subjectregistration')
        }

      }
  const [open, setOpen] = React.useState(false);

      function handleClosePopup() {
        setOpen(false)
      }
    return (
        <div>
            <NavigationBar studyDropdwn={studyDropdwn} title={'Subjects'} rolecode={getRoleCode} handleOptionChange={handleOptionChange} handleFilteredData={handleStudyChange} />
            {/* <PIFlowLeftNavBar /> */}
            <div className='main_body mb-4'>

                {currentPage === 1 && <Container fluid className='pt-3 pb-4 py-lg-4 py-md-4 py-xxl-4 mblbgclr'>
                    <div className=''>
                        <Stack direction="horizontal" gap={2} className="p-0 pb-md-3 pb-lg-3 pb-xxl-3 add_subject_stack">
                            <div className=" d-flex justify-content-between justify-content-md-start gap-2 pilistfiltrs">
                                <div >
                                    {
                                        <Select
                                            selectedOption={doseSelected}
                                            selectdivstyl={""}
                                            name={"classification"}
                                            width={"auto"}
                                            label={""}
                                            options={doseOptions}
                                            initialValue={"Doses"}
                                            onChange={handleOptionSelectDose}
                                        />
                                    }
                                </div>
                                <div>
                                    {
                                        <Select
                                            selectedOption={statusSelected}
                                            selectdivstyl={""}
                                            name={"classification"}
                                            width={"100%"}
                                            label={""}
                                            options={statusOptions}
                                            initialValue={"Status"}
                                            onChange={handleOptionSelectStatus}
                                        />
                                    }

                                </div>
                                <div className='clr_btn_mdqr_two'>
                                    <button className="orange_btn" onClick={handleClearFilters}>Clear</button>
                                </div>
                                <div className='clr_btn_mdqr'>
                                    <button className="orange_btn" onClick={handleClearFilters}>Clear</button>
                                </div>
                            </div>
                            <div className="ms-0 ms-lg-auto ms-md-auto gap-3 d-md-flex pilistaddbtns desktop-view">
                                    {<button className="orange_btn"
                                    style={{opacity:studyDtls?.estimated_subjects_reached==1 ?"50%":""}}
                                     onClick={handleCheckEstimation}>
                                    Add Subject
                                    </button>}
                                    {subjectList?.length !== 0 && (
                                    <button className="orange_btn" onClick={() => navigate('/addnewdosetosubject')}>
                                        Add Dose
                                    </button>
                                    )}
                                    {subjectList?.length !== 0 && (
                                    <button className="orange_btn pisubaebtndsk" onClick={() => navigate('/addnewadverseevent')}>
                                        Add Adverse Event
                                    </button>
                                    )}
                            </div>
  {/* Mobile view */}
                <div  className='w-xs-100'>
                    <div className="dropdown mobile-view mb-2 ">
                        <button className="dropdown-toggle custom-dropdown-toggle custom_scc" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                        <svg width="20" height="20" viewBox="0 0 36 36">
                            <path fill="#000000" d="M16 16v14h4V20z"></path>
                            <path fill="#000000" d="M30 16H20l-4 4h14z"></path>
                            <path fill="#000000" d="M6 16v4h10l4-4z"></path>
                            <path fill="#000000" d="M20 16V6h-4v14z"></path>
                            <path fill="none" d="M0 0h36v36H0z"></path>
                            </svg>
                        <span className="custom-icon-text">Add</span>
                        </button>
                        <ul className="dropdown-menu C-pointer">
                            { <li><a className="dropdown-item" onClick={handleCheckEstimation}
                            >Add Subject</a></li>}
                            <li><a className="dropdown-item" onClick={() => navigate('/addnewdosetosubject')}>Add Dose</a></li>
                            <li><a className="dropdown-item" onClick={() => navigate('/addnewadverseevent')}>Add Adverse Event</a></li>
                        </ul>
                    </div>     
                </div>       
                    </Stack>
                        <div className="">
                        <Row className="d-flex pb-2 p-0">
                            {dashboardCards?.map((card, index) => {
                                return (
                                    <Col key={index} xs={6} md={4} className={`pb-md-0 pe-0 p-0 ${index ===0 ||index===2?"pe-2 pb-2" : index===1 ? 'pb-2 pe-md-2':''}`}>
                                        <div className='card-container C-pointer' style={{ backgroundColor: card.bgcolor , outline: selectedOption === card.id ? "2px solid black" :""}}
                                         onClick={() => handleRadioChange(card.id)}
                                        >
                                            <div className='content'>
                                                <span>{card.count}</span>
                                                <img src={card.image} alt="" />
                                            </div>
                                            <div className='desc'>{card.desc}</div>
                                        </div>
                                    </Col>
                                )
                            })}
                        </Row>
                        </div>
                    </div>
                    {subjectList && subjectList.length > 0 ? (
                        <Container fluid className='pitable_container p-0'>
                            <Row className='searchbar'>
                                <Col className='searchFiled gap-2 gap-md-3 '>

                                    <input type="text" value={searchText}  placeholder={placeHoldTxt} onChange={handleSearchData}  style={{ width: `${placeHoldTxt.length * 10}px`}}/>
                                    <div className=" ">
                                       
                                    </div>

                                </Col>
                            </Row>

                            <div>
                                {loading_flag  ? (
                                    <div className=''>
                                        <img
                                            className="atrium_loader"
                                            src="/images/circle-effect-loading.gif"
                                            alt="Loader"

                                        />
                                    </div>
                                ) : (
                                    <div className="table-scroll-container desktop-view" style={{border:"1px solid #E1E5E7 "}}>
                                        {filteredData?.length > 0 ?
                                            <Table bordered size="sm" className='pitable  mb-0'>
                                                <thead className='sticky_table_header'>
                                                    <tr>
                                                        <th> S.No</th>
                                                        <th className='sticky-header'>
                                                        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                                                        <span style={{ fontSize: 14, fontWeight: 600, marginTop: 0,paddingLeft:"40px" }}>Subject ID</span>
                                                        <svg width="30" height="30" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" style={{float:"right"}}>
                                                                <g id="icon_sort">
                                                                    <path id="icon" d="M13.3471 21.1433C13.1481 21.4277 12.7269 21.4277 12.5279 21.1433L8.23821 15.0152C8.00624 14.6839 8.24332 14.2285 8.64783 14.2285H17.2272C17.6317 14.2285 17.8688 14.6839 17.6368 15.0152L13.3471 21.1433Z" fill={desc?"black":"#E1E5E7"} onClick={handleDescending} className='svg-cursor'/>
                                                                    <path id="icon_2" d="M13.3471 4.31368C13.1481 4.02932 12.7269 4.02932 12.5279 4.31368L8.23821 10.4418C8.00624 10.7732 8.24332 11.2285 8.64783 11.2285H17.2272C17.6317 11.2285 17.8688 10.7732 17.6368 10.4418L13.3471 4.31368Z" fill={asc?"black":"#E1E5E7"} onClick={handleAscending} className='svg-cursor'/>
                                                                </g>
                                                            </svg>
                                                            </div>
                                                        </th>
                                                        <th className='phn_fld'>Phone Number        
                                                        </th>
                                                        <th>Last Updated                                                            
                                                        </th>
                                                        <th style={{ minWidth: "90px" }}>Initials
                                                        </th>
                                                        <th style={{ minWidth: "70px" }}>Age
                                                        </th>
                                                        <th style={{ minWidth: "70px" }}>Sex
                                                        </th>
                                                        <th style={{ minWidth: "70px" }}>Dose
                                                        </th>
                                                        <th style={{ minWidth: "90px" }}>Events
                                                        </th>
                                                        <th>Status
                                                        </th>
                                                        <th>Action
                                                        </th>
                                                    </tr>
                                                </thead>

                                                <tbody className='tableBodyScroll'>
                                                    {filteredData?.map((i, index) => {
                                                        switch (i.sex) {
                                                            case "Male":
                                                                i.sex = "M";
                                                                break;
                                                            case "Female":
                                                                i.sex = "F";
                                                                break;
                                                            case "Others":
                                                                i.sex = "O";
                                                                break;
                                                            default:
                                                                break;
                                                        }
                                                        const numbersArray = i.subject_code.split('/').filter(item => item.trim() !== '');
                                                        let lastNumber=[]
                                                        if (numbersArray.length > 0) {
                                                            lastNumber = numbersArray[numbersArray.length - 1];

                                                        }
                                                        const formatedDate=formatDate(i.lastUpdated)
                                                        
                                                        return (
                                                            <tr key={i.index} className='text_left_table'>
                                                                <td className='text_right_sno'> {index + 1} </td>
                                                                {/* <td >{lastNumber}</td> */}
                                                                <td >{i.subject_code ? i.subject_code:"-"}</td>
                                                                <td>{i.phone_number ? i.phone_number:"-"}</td>
                                                                <td className='text-center'>{formatedDate}</td>
                                                                <td>{i?.first_name ? i?.first_name[0] + i?.last_name[0] : "-"}</td>
                                                                <td>{i.age ? i.age:"-"} Yrs</td>
                                                                <td>{i.sex ? i.sex:"-"} </td>
                                                                <td>{i.dose ? i.dose:"-"}</td>
                                                                <td>{i.events }</td>
                                                                <td style={{ color: getStatusTextColor(i.status) }}>{i.status ? i.status:"-"}</td>
                                                                <td className=' mb-0 align-items-center viewbtnstylmbl' onClick={() => handleSubjectData(i)}>
                                                                    <div style={{ marginLeft: i.status === 'ON STUDY' && window.screen.width <= 600 ? '40px' : '0' }}>
                                                                        <article>{i.status ? i.status:"-"}</article>
                                                                    </div>
                                                                    <h3 className='mb-0'>{">"}</h3>
                                                                </td>
                                                                <td className='viewbtnstyl'><button className="gray_btn px-3" onClick={() => handleSubjectData(i)}>View</button> </td>
                                                            </tr>)
                                                    })}
                                                </tbody>
                                            </Table>
                                            :
                                                <Table bordered size="sm" className="pitable">
                                                    <thead>
                                                        <tr>
                                                            <th> S.No</th>
                                                            <th>Subject ID
                                                            </th>
                                                            <th className='phn_fld'>Phone Number
                                                            </th>
                                                            <th>Last Updated
                                                            </th>
                                                            <th style={{ minWidth: "90px" }}>Initials
                                                            </th>
                                                            <th style={{ minWidth: "70px" }}>Age
                                                            </th>
                                                            <th style={{ minWidth: "70px" }}>Gender
                                                            </th>
                                                            <th style={{ minWidth: "70px" }}>Dose
                                                            </th>
                                                            <th style={{ minWidth: "90px" }}>Events
                                                            </th>
                                                            <th>Status
                                                            </th>
                                                            <th>Action
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td colSpan="20" className="bg-white border py-4 text-center">
                                                                No records found
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </Table>

                                        }
                                    </div>
                                )}
                                <div className="d-flex flex-column gap-1  d-md-none border ">
                                <div className="d-flex justify-content-between ps-2 pe-5  sticky_table_header " style={{fontSize:"13px" ,backgroundColor:"#dee2e6"}}>
                           
                                <div style={{ fontWeight: 'bold' }} className='mt-2'>SubjectID</div>
                                <div style={{ marginRight: '4.7rem', fontWeight: 'bold' }} className='mt-2'>Dose</div>
                                <div style={{ marginRight: '3.3rem', fontWeight: 'bold' }} className='mt-2'>Status</div>
                                </div>
                                    <Accordion className='acrdn-main-pisubjmbl' flush >
                                        {filteredData?.map((i,index) => {
                                            switch (i.sex) {
                                                            case "M":
                                                                i.sex = "Male";
                                                                break;
                                                            case "F":
                                                                i.sex = "Female";
                                                                break;
                                                            case "O":
                                                                i.sex = "Others";
                                                                break;
                                                            default:
                                                                break;
                                                        }
                                            const numbersArray = i.subject_code.split('/').filter(item => item.trim() !== '');
                                            let lastNumber = []
                                            if (numbersArray.length > 0) {
                                                lastNumber = numbersArray[numbersArray.length - 1];
                                            }
                                            return (
                                                <Accordion.Item key={index} eventKey={index} className='acrdn-item-pisubjmbl d-flex flex-column gap-2 bg-light'>
                                                    <Accordion.Header className='acrdn-header-pisubjmbl row border-0' >
                                                        <div>{lastNumber}</div>
                                                        {/* {i.status === "ON STUDY" ?
                                                        <div style={{marginLeft:"-50px"}}>{i.dose}</div> 
                                                        :
                                                        <div >{i.dose}</div>
                                                        } */}

                                                        {
                                                            i.status === "ON STUDY" 
                                                            ? <div style={{ marginLeft: "-49px" }}>{i.dose}</div> 
                                                            : i.status === "CONCLUDED STUDY"
                                                                ? <div style={{ marginLeft: "-20px" }}>{i.dose}</div>

                                                                    :  <div >{i.dose ? i.dose :"-"}</div>
                                                        }

                                                        <div style={{marginRight:"-30px", color: getStatusTextColor(i.status)}} >{i.status?.length>23?i.status.slice(0,23)+"..":i.status}</div>
                                                    </Accordion.Header>
                                                    <Accordion.Body className='acrdn-body-pisubjmbl'>
                                                        <div className='row w-100 border-0'>
                                                            <div className='col'>
                                                                <p>Age</p>
                                                                <p>Sex</p>
                                                                <p>Contact</p>
                                                            </div>
                                                            <div className='col'>
                                                            <p>{i.age+" Yrs"}</p>
                                                                <p>{i.sex ? i.sex :"-"}</p>
                                                                <p>{i.phone_number ? i.phone_number:"-"}</p>
                                                            </div>
                                                        </div>
                                                    <div className="row w-100 border-0 d-flex justify-content-end">
                                                        <Col className='view_link' onClick={() => handleSubjectData(i)}>View </Col>
                                                    </div>
                                                    </Accordion.Body>
                                                </Accordion.Item>
                                            )
                                        })}
                                    </Accordion>
                                </div>
                            </div>
                        </Container>
                    ) : subjectList === null && localStorage.study_id ? <div className=''>
                            <img
                                className="atrium_loader"
                                src="/images/circle-effect-loading.gif"
                                alt="Loader"

                            />
                        </div> : (
                        <>
                            {/* <img className='mt-5' src="./images/no_subjects.svg" alt="Telephone" />
                        <h5>No Subjects Are Avaliable</h5> */}
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginTop: '5rem' }}>
                                <img src="./images/no_subjects.svg" alt="Telephone" />
                                <h5>No Subjects Are Available</h5>
                            </div>
                        </>
                    )}
                </Container>}

                {  loading_flag ? 
                    <div className=''>
                    <img
                        className="atrium_loader"
                        src="/images/circle-effect-loading.gif"
                        alt="Loader"
                    />
                </div> : (currentPage === 2 && subjectProfile && modifiedData) &&
                    <Container fluid className='pt-2 page_two_styl'>
                        <Row className='d-flex justify-content-between'>
                            <Col  className="ps-0"><button className="white_btn_back white_btn py-2" onClick={handlePageandStudy}>{'< '}Back</button> </Col>
                            <Col className='d-flex justify-content-end pe-0'><button className="orange_btn"  onClick={addAdverseEvent}>+ Add Adverse Events</button> </Col>
                        </Row>
                        <Container fluid className='pt-3 pt-md-2 p-0'>
                            <Row className='SVdtl_Main'>
                                <Col xs={12} lg={4} className='section_1'>
                                    <div className='pisubj_left_main'>
                                        <div className='title_cls title_clsmbl'>
                                            <h5>Subject Profile</h5>
                                        </div>
                                        <div className="left_content_subjlist">
                                            <div className='body_cls'>
                                                <span><h6 className='mb-0'>{subjectProfile?.first_name}{" "+subjectProfile?.last_name}</h6></span>
                                                <span><h6>{subjectProfile?.subject_code}</h6></span>
                            
                                                <div className="row">
    <div className="col-6 p-0">
        <div className="mb-0">
            <span className="mb-0">Age:</span> <span className="space_yrs highlet-left">{subjectProfile?.age} Yrs</span>
        </div>
    </div>
    <div className="col-6">
        <div className="mb-0">
            <span className="mb-0">Height:</span> <span className='space_height highlet-left'>{subjectProfile?.height ? subjectProfile.height : 0} cm</span>
        </div>
    </div>
</div>
<div className="row">
    <div className="col-6 p-0">
        <div className="mb-0">
            <span className="mb-0">Gender:</span> <span className='highlet-left'>{subjectProfile?.sex}</span>
        </div>
    </div>
    <div className="col-6">
        <div className="mb-0">
            <span className="mb-0">Weight:</span> <span className='highlet-left'>{subjectProfile?.weight}Kg</span>
        </div>
    </div>
</div>
<div className="row">
    <div className="col-12 p-0">
        <div className="mb-0">
            <span className="mb-0">BMI:</span> <span className="space_bmi highlet-left">{calculateBMI(subjectProfile?.weight, subjectProfile?.height)} (BMI)</span>
        </div>
    </div>
</div>
                                                    

                                                <span className='d-flex justify-content-between w-100'>
                                                    <h6 >+91 {subjectProfile?.phone_number}</h6>
                                                    <img className='' src="./images/icons/Telephone.svg" alt="Telephone" />

                                                </span>
                                                <span className='d-flex justify-content-between w-100'>
                                                    <h6 className='site_add'>{subjectProfile['Site.site_name']} </h6>
                                                    <img className='' src="./images/icons/location.svg" alt="Location Icon" />
                                                </span>
                                            </div>
                                            <div className='px-3 s2 studydtlsmbl'>
                                                {myArray.map((i, index) => {
                                                    return (
                                                        <div className=
                                                            {`${window.screen.width<=600?'studytabmbl':"studytab"}`}
                                                            key={index}>
                                                            <span className='text-start'>{i.title}</span>
                                                            <span className="study_tab_desc">{i.description}</span>
                                                        </div>
                                                    )
                                                })}
                                                {/* <h6 className='h7 pisubfooter'>Quality Reviewer Comments</h6>
                                                <div className='studytab pisubleft'>
                            <span className="study_tab_desc">Please review the causality again.</span>
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col className=' pisub' >
                                    <div className='title_cls right_cntnt right_cntntmbl'>
                                        <h5 className='title'>Adverse Events</h5>
                                    </div>
                                    <div className='px-md-5 px-3 pt-md-5 pt-4 right_content_stepper'>
                                        <div className='text-left '>
                                            <Stepper events={modifiedData} handleAE={(id) => handleAE(id)} />
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </Container>
                }

            </div>
            <PopUpAlert
          handleClose={handleClosePopup} 
          open={open}
          // title={"?"}
          msg={<span className='lower'>Cannot create subject, as we have reached the expected limit for this study.</span>}
          close={"Close"}
        //   actionbtn={'Sure'}
          onConfirm={''}
        />
        </div>
    );
};

export default PISubjectsList;

const Stepper1 = ({ events, handleAE }) => {
    return (
        <Row className=''>
            <Col className='vertical_stepper_main col-3'>
                {events?.map((i, index) => {
                    let formattedString = i.day?.replace(/(\D)(\d+)/, '$1 $2');
                    return (
                        <div className='vertical_stepper_section' key={index}>
                            <Col className='dataleft'>
                                <div className='fs-6'>{formattedString}</div>
                                <div className='date'>{moment(i.dateOfevent).format("DD-MM-YYYY")}</div>
                            </Col>

                        </div>
                    )
                })}
            </Col>
            <Col className='vertical_stepper_main'>
                <div className="vertical_stepper_dots  ">
                    {events?.map((i, index) => {
                        let yellowDot
                        let seriousDot
                        i.eventClassification?.map(i => {
                            yellowDot = (i.adverse_events?.length !== 0)
                        })
                        i.eventClassification?.map(i => {

                            seriousDot = i.serious_adverse_events?.length !== 0
                        })

                        {/* let yellowDot = i.eventClassification?.some(obj => Object.keys(obj).includes('adverse_events')) */ }
                        {/* let seriousDot = i.eventClassification?.some(obj => Object.keys(obj).includes('serious_adverse_events')) */ }
                        return (
                            <div className='vertical_stepper_section' key={index}>

                                <Col className={`dot ${seriousDot && yellowDot ? "C-red" : seriousDot && !yellowDot ? "C-red" : !seriousDot && yellowDot ? "C-orange" : "C-gray"}`} />

                                <div>
                                    {i.eventClassification?.map((i, index) => {

                                        return (<div key={index} className='' >
                                            <div className='' >
                                                <div className='adveventstyl'>{i.adverse_events?.map((item, index) => (
                                                    <div key={item.adverse_event_mapping_id} className='clickable-string serious-adverse-event' onClick={() => handleAE(item.adverse_event_mapping_id,true)}>
                                                        {item.study_aebank_event_title}
                                                        {index !== i.adverse_events?.length - 1 ? ',' : ''}
                                                    </div>
                                                ))}</div>
                                                <div className='adveventstyl'>{i.serious_adverse_events?.map((item, index) => (
                                                    <div key={item.adverse_event_mapping_id}>
                                                        {item.serious_adverse_event_name}
                                                        {index !== i.serious_adverse_events?.length - 1 ? ',' : ''}
                                                    </div>
                                                ))}</div>
                                            </div>
                                        </div>)
                                    })}
                                </div>


                            </div>
                        )
                    })}
                </div>
            </Col>


            {/* <Col className='vertical_stepper_main '>
                {events?.map((i, index) => {
                    let yellowDot = i.eventClassification?.some(obj => Object.keys(obj).includes('adverse_events'))
                    let seriousDot = i.eventClassification?.some(obj => Object.keys(obj).includes('serious_adverse_events'))
                    return (
                        <div className='' key={index}>


                            <Col className=''>{i.eventClassification?.map((i, index) => {
                                return <div key={index}>
                                    {i.adverse_events}{i.serious_adverse_events}


                                </div>
                            })}</Col>
                        </div>
                    )
                })}
            </Col> */}
            
        </Row>
    );
};

const Stepper = ({ events, handleAE }) => {
    return <>
    <div className='mb-3 dor_note'>{"("}<span className='text-danger'>*</span>{")"} - The date of resolution has not been added to the events.</div>
    { events?.map((i, index) => {
            let yellowDot
            let seriousDot
            let greenDot = i?.eventClassification && i?.eventClassification[0]?.adverse_events[0]?.isEventEnd || i?.eventClassification && i?.eventClassification[0]?.serious_adverse_events[0]?.isEventEnd
           
            let greenOrange = ((i?.eventClassification && i?.eventClassification[0]?.ongoingAdverseEvents >= 1) || (i?.eventClassification && i?.eventClassification[0]?.startedAdverseEvents >= 1)) && i?.eventClassification && i?.eventClassification[0]?.endedEvents >= 1
            let saeStartEnd = i?.eventClassification && i?.eventClassification[0]?.endedEvents >= 1 && (i?.eventClassification && i?.eventClassification[0]?.startedSeriousAdverseEvents >= 1 || i?.eventClassification && i?.eventClassification[0]?.ongoingSeriousAdverseEvents >= 1)
            
            
            let aeStartEnd = i?.eventClassification && i?.eventClassification[0]?.endedEvents >= 1 && i?.eventClassification && i?.eventClassification[0]?.startedAdverseEvents >= 1
           
            i.eventClassification != null && i.eventClassification?.map(i => {
                yellowDot = (i.adverse_events?.length !== 0)
            })
            i.eventClassification != null && i.eventClassification?.map(i => {
                seriousDot = i.serious_adverse_events?.length !== 0
            })
            let formattedStringg = i.day?.replace(/(\D)(\d+)/, '$1 $2');
            return (
                <Row className='stprmainmbl' >
                    <div className='vertical_stepper_main col-5 col-md-3 col-lg-3 col-xxl-3'>
                        <div className='vertical_stepper_section' key={index}>
                            <Col className='dataleft'>
                                <div className=' fw-bold'>{formattedStringg}</div>
                                <div className='date'>{moment(i.dateOfevent).format("DD-MM-YYYY")}</div>
                            </Col>
                        </div>
                    </div>
                    <div className='vertical_stepper_main col'>
                        <div className={`vertical_stepper_dots ${events.length-1 == index ? "border-0" : ""}`}>
                            <div className='vertical_stepper_section' key={index}>
                                <Col className={`${(greenOrange || saeStartEnd) ? "dot-green-inside": "dot"} ${aeStartEnd && "outer-orange"}  ${saeStartEnd ? "outer-red" :greenOrange ? "outer-orange" : greenDot ? "C-green" : seriousDot ? "C-red" : !seriousDot && yellowDot ? "C-orange" : "C-gray"}`} />

                                {i.eventClassification!=null && i.eventClassification?.map((i, index) => {
                                    const startEvents = i.adverse_events.filter((each) => each.isEventStart)
                                    const endEvents = i.adverse_events.filter((each) => each.isEventEnd)
                                    const ongoingAE = i.adverse_events.filter((each) => each.isEventStart ===  false && each.isEventEnd === false)
                                    const ongoingSAE = i.serious_adverse_events.filter((each) => each.isEventStart ===  false && each.isEventEnd === false)
                                    const startSaEvents = i.serious_adverse_events.filter((each) => each.isEventStart)
                                    const endSaEvents = i.serious_adverse_events.filter((each) => each.isEventEnd)
                                    const noOfEvents = startEvents.length+endEvents.length+ongoingAE.length+ongoingSAE.length+startSaEvents.length+endSaEvents.length
                                    return (
                                        <div key={index} className={`aestylmbl ${noOfEvents >= 3 && "pb-4"}`} >
                                            <div className='adveventstyl'>
                                                {ongoingAE.length > 0 && <div className="d-flex flex-wrap">
                                                {ongoingAE.length > 0 && ongoingAE.map((each,index) => {
                                                    return  <div key={each.adverse_event_mapping_id} className='aechildmbl clickable-string serious-adverse-event' onClick={() => handleAE(each.adverse_event_mapping_id, true)}>
                                                    {each.study_aebank_event_title}
                                                    {index === ongoingAE?.length - 1 ? (ongoingAE?.length === 1 && startEvents?.length === 0 && endEvents?.length === 0) ? "" :  '.' : ','}
                                                </div>
                                                })}
                                                </div>}
                                                {startEvents.length > 0 && <div className="d-flex flex-wrap">
                                                {startEvents.length > 0 && startEvents.map((each,index) => {
                                                    return <div key={each.adverse_event_mapping_id} className='aechildmbl clickable-string serious-adverse-event' onClick={() => handleAE(each.adverse_event_mapping_id, true)}>
                                                    {<span>{index === 0 ? "Start: ": "" }{each.study_aebank_event_title}{each.isDateOfResolutionGiven === false && <span className='text-danger'>*</span> }</span>}
                                                    {index === startEvents?.length - 1 ? (startEvents?.length === 1 && endEvents?.length === 0) ? "" : '.' : ','}
                                                </div>
                                                })}</div>}
                                                {endEvents.length > 0 && <div className="d-flex flex-wrap">
                                                {endEvents.length > 0 && endEvents.map((each,index) => {
                                                    return <div key={each.adverse_event_mapping_id} className='aechildmbl clickable-string serious-adverse-event' onClick={() => handleAE(each.adverse_event_mapping_id, true)}>
                                                    {<span>{index === 0 ?"End: " : ""}{each.study_aebank_event_title}</span>}
                                                    {index === endEvents?.length - 1 ? (endEvents?.length === 1) ? "" : '.' : ','}
                                                </div>
                                                } )}</div>}
                                            </div>

                                            <div className='adveventstyl'>
                                              {ongoingSAE.length > 0 && <div className="d-flex flex-wrap">
                                                {ongoingSAE.length > 0 && ongoingSAE.map((each,index) => {
                                                    return <div key={each.adverse_event_mapping_id} className='aechildmbl clickable-string serious-adverse-event' onClick={() => handleAE(each.adverse_event_mapping_id, true)}>
                                                    <span className="text-danger">{each.study_aebank_event_title}-{each.serious_adverse_event_name}</span>
                                                    {index === ongoingSAE.length-1 ? (ongoingSAE?.length === 1 && startSaEvents?.length === 0 && endSaEvents?.length === 0) ? "" :  '.'  : ','}
                                                </div>
                                                })}</div>}
                                              {startSaEvents.length > 0 && <div className="d-flex flex-wrap">
                                                {startSaEvents.length > 0 && startSaEvents.map((each,index) => {
                                                    return <div key={each.adverse_event_mapping_id} className='aechildmbl clickable-string serious-adverse-event' onClick={() => handleAE(each.adverse_event_mapping_id, true)}>
                                                    {<span>{index === 0 ? "Start: ": "" }<span className="text-danger">{each.study_aebank_event_title}-{each.serious_adverse_event_name}</span></span>}
                                                    {index === startSaEvents?.length - 1 ? (startSaEvents?.length === 1 && endSaEvents?.length === 0) ? "" : '.' : ','}
                                                </div> 
                                                })}</div>}
                                                {endSaEvents.length > 0 && <div className="d-flex flex-wrap">
                                                {endSaEvents.length > 0 && endSaEvents.map((each,index) => {
                                                    return <div key={each.adverse_event_mapping_id} className='aechildmbl clickable-string serious-adverse-event' onClick={() => handleAE(each.adverse_event_mapping_id, true)}>
                                                    {<span>{index === 0 ? "End: ": "" }<span className="text-danger">{each.study_aebank_event_title}-{each.serious_adverse_event_name}</span></span>}
                                                    {index === endSaEvents?.length - 1 ?(endSaEvents?.length === 1) ? "" : '.' : ','}
                                                </div>
                                                })}</div>}
                                            </div>

                                        </div>)
                                })}
                            </div>
                        </div>
                    </div>
                </Row>
            )})}
    </>
       
    
}


 

export const PIEventCards = ({data}) => {
    return (
        <Row className="d-flex pb-2 p-0">
        {data?.map((card, index) => {
            return (
                <Col key={index} xs={6} md={4} className={`pb-md-0 pe-0 p-0 ${index ===0 ||index===2?"pe-2 pb-2" : index===1 ? 'pb-2 pe-md-2':''}`}>
                    <div className='card-container' style={{ backgroundColor: card.bgcolor }}>
                        <div className='content'>
                            <span>{card.count}</span>
                            <img src={card.image} alt="" />
                        </div>
                        <div className='desc'>{card.desc}</div>
                    </div>
                </Col>
            )
        })}
    </Row>
    );
};

 
